module.exports = __webpack_public_path__ + "static/media/under-maintenance.47434e4b.svg";